import { styles } from './ConversationDetail.styles';

export const ConversationDetailLoading = () => (
	<>
		<header className={styles.topbar}>
			<div className="h-md w-[200px] animate-pulse rounded bg-grey-25" />
		</header>
		<main className={styles.content}>
			<div className="flex items-start gap-xs">
				<div className="h-[44px] w-[44px] animate-pulse rounded-full bg-grey-25" />
				<div className="flex flex-col gap-2xs">
					<div className="h-sm w-[160px] animate-pulse rounded bg-grey-25" />
					<div className="h-[28px] w-[192px] animate-pulse rounded bg-grey-25" />
				</div>
			</div>
			<div className="h-[80px] animate-pulse rounded-lg bg-grey-25" />
			{['a', 'b', 'c', 'd'].map((k) => (
				<div key={`turn-${k}`} className="h-[80px] animate-pulse rounded-lg bg-grey-25" />
			))}
		</main>
	</>
);
